import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useDeleteLlmClient = () => {
  const {
    data: isDeleted,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const deleteLlmClient = async (llmName: string, id: string) => {
    await call(`/admin/llm/${llmName}/clients/${id}`, "DELETE");
  };

  return {
    deleteLlmClient,
    isDeleted,
    isLoading,
    isFailed,
  };
};
